import { Outlet } from "@remix-run/react";
import { Panel } from "~/components/base/panel";

// app/routes/login.tsx
export default function Login() {
  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md dark:text-white">
        <img
          className="mx-auto h-20 w-auto"
          src="/logo-small.png"
          alt="Your Company"
        />
        <h2 className="mt-6 text-center text-2xl font-bold leading-9 tracking-tight">
          Sign in to your Jordan's account
        </h2>
        <a href="/teammate" className="pt-2 block text-xs mx-auto text-center">
          Click here to go to the teammate login
        </a>
      </div>

      <div className="mt-7 sm:mx-auto sm:w-full sm:max-w-[480px] px-4 w-full">
        <Panel>
          <Outlet />
        </Panel>
      </div>
    </div>
  );
}
